import React, { Component, Fragment } from 'react'
import Link from "next/link"
import { applyLang } from "../../i18n";
import { Divider } from "antd";
import { t } from "@lingui/core/macro"
import { Trans } from "@lingui/react/macro"

export default class Footer extends Component {

    render() {
        const context = this.props.context
        const { org, config } = context

        const isMobile = context.isMobile

        return(
            <>
                {/*
                <div style={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center",backgroundColor:"#000",color:"#FFF",gap:15,paddingBottom:30,paddingTop:20}}>

                    <h5 style={{}}>{org.name}</h5>

                </div>
                */}


                <div style={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center",backgroundColor:"#C2E0F4",gap:15,paddingTop:20}}>

                    <img src={"/logo-unisoft-vertical.png"} style={{width:150,height:80,objectFit:"contain"}}/>

                    {isMobile ?(
                        <div style={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center",gap:0,paddingBottom:30}}>
                            <p>
                                <Trans>Propulsé par</Trans>
                                <strong><a rel="noopener" href="https://unisoft.world" target="_blank" style={{color: "rgb(35, 111, 161)"}}> unisoft.world</a></strong>
                            </p>
                            <p>{new Date().getFullYear()} <Trans>tous droits réservés</Trans></p>
                        </div>
                    ):(
                        <div style={{display:"flex",justifyContent:"center",alignItems:"center",gap:10}}>
                            <p>
                                <Trans>Propulsé par</Trans>
                                <strong><a rel="noopener" href="https://unisoft.world" target="_blank" style={{color: "rgb(35, 111, 161)"}}> unisoft.world</a></strong>
                            </p>
                            <p>/</p>
                            <p>{new Date().getFullYear()} <Trans>tous droits réservés</Trans></p>
                        </div>
                    )}

                </div>
            </>
        )

        /*
        return (
            <div style={{ backgroundColor: "#000", color: "#FFF" }}>
                <div className={"container"}>
                    <div style={{ display: "flex", flexDirection: isMobile ? "column" : "row", justifyContent: "space-between", padding: "2rem 0" }}>

                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: 20,
                            textAlign: "start",
                            width: "80vw",
                        }}>

                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 5 }}>
                                <img src={"/charithon/3.png"} style={{ height: isMobile ? 65 : 110 }} />
                                <span style={{ color: "#FFF", fontSize: isMobile ? 30 : 40, marginRight: 10 }}>X</span>
                                <img src={"/logo-full-white.png"} style={{ width: isMobile ? 120 : 200 }} />
                            </div>

                            <span style={{ fontSize: isMobile ? "0.8rem" : "1rem", marginTop: isMobile ? 0 : "0.6rem" }}>
                                <Trans>Plateforme de gestion et d'encaissement tout-en-un pour structures associatives</Trans>
                            </span>

                            <div style={{ display: "flex", alignItems: "flex-start", flexDirection: "column", gap: 20, marginTop: isMobile ? 0 : "0.5rem" }}>

                                <a href={"tel:0767377415"} style={{ color: "inherit" }}>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: 10
                                    }}>
                                        <img src={"/campagne/icons/phone.png"} style={{ width: isMobile ? 15 : 20 }} />
                                        <span style={{ fontSize: isMobile ? "0.8rem" : "1rem", marginTop: 2 }}>07 67 37 74 15</span>
                                    </div>
                                </a>

                                <a href={"mailto:contact.synassist@gmail.com"} style={{ color: "inherit" }}>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: 10
                                    }}>
                                        <img src={"/campagne/icons/email.png"} style={{ width: isMobile ? 15 : 20 }} />
                                        <span style={{ fontSize: isMobile ? "0.8rem" : "1rem", marginTop: 2 }}>contact.synassist@gmail.com</span>
                                    </div>
                                </a>

                                <a href={"https://kehila.io"} target={"_blank"} style={{ color: "inherit" }}>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: 10
                                    }}>
                                        <img src={"/campagne/icons/www.png"} style={{ width: isMobile ? 15 : 20 }} />
                                        <span style={{ fontSize: isMobile ? "0.8rem" : "1rem", marginTop: 2 }}>https://kehila.io</span>
                                    </div>
                                </a>

                            </div>

                        </div>

                    </div>
                </div>

                <div style={{
                    backgroundColor: "#000",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 2rem",
                    padding: "1.5rem",
                    borderTop: "1px solid grey",
                    color: "grey",
                    textAlign: "center"
                }}>
                    <p style={{ fontSize: "0.9rem" }}>
                        {t`© Copyright ${new Date().getFullYear()} SAS MIMTECH tous droits réservés`}
                    </p>
                    <p>
                        <a style={{ color: "grey" }} href={"/docs/CGU.pdf"} target={"_blank"}>
                            <Trans>Conditions générales d'utilisation</Trans>
                        </a>
                    </p>
                    <p>
                        <a style={{ color: "grey" }} href={"/docs/Politique-de-Confidentialité.pdf"} target={"_blank"}>
                            <Trans>Politique de Confidentialité</Trans>
                        </a>
                    </p>
                </div>
            </div>
        )
         */
    }
}
